
import React from "react";
import {
  BrowserRouter as Router, Link,
  useLocation
} from "react-router-dom";
import "../SecurityPlatforms.css";
import "../../../pages/SecuritySchools.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import LinkTag from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SAPCard() {
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <LinkTag
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </LinkTag>
            ,
            <LinkTag
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </LinkTag>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <Link
            className="menu_title"
            to={{
              pathname: "/securitySchools",
              state:{tabID:'I&Dmanagement'}
          }}
          >
            Identity & Access Management
          </Link>
          ) : (
            ""
          )}
          {value === 1 ? (
             <Link
             className="menu_title"
             to={{
               pathname: "/securitySchools",
               state:{tabID:'Infrastructure'}
           }}
         >
           Infrastructure Security
         </Link>
          ) : (
            ""
          )}
          {value === 2 ? (
           <Link
           className="menu_title"
           to={{
             pathname: "/securitySchools",
             state:{tabID:'platformSecurity'}
         }}
       >
         Platform Security 
       </Link>
          ) : (
            ""
          )}
          {value === 3 ? (
            <Link
            className="menu_title"
            to={{
              pathname: "/securitySchools",
              state:{tabID:'cloudsecurity'}
          }}
        >
          Cloud Security
        </Link>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            SAP GRC Training
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <IdentiyAccessManagement />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <div className="keyObjective-wrapper">
              <div className="topics-Wrapp">
                <div className="topics-Row2">
                  <div className="arrowBox-heading">SAP GRC Training</div>
                  <div className="topics-list2">
                    <ul>
                      <li>GRC-SAP Risk Management</li>
                      <li>Audit Management</li>
                      <li>AC</li>
                      <li>Process Control​</li>
                    </ul>
                  </div>
                  <div className="bottomCorner">
                    <img
                      src="images/SecuritySchools/SecurityPlatforms/bottom-BG.png"
                      className="img-responsive"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default SAPCard;

